import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Button, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { imageUploadHandler } from 'utils/tools';
import {
  acceptOrder,
  getByIdOrders,
  getOrderHistory,
} from 'redux/orders/actions';
import GridPhotos from 'components/common/GridPhotos';
import { getOrderHistoriesSelectors } from 'redux/orders/selectors';

const WaitingApproved = ({ onCancel, order, item }) => {
  const dispatch = useDispatch();
  const [note, setNote] = useState('');
  const [isReject, setReject] = useState(false);
  const orderHistories = useSelector(getOrderHistoriesSelectors);
  const isLast = orderHistories[orderHistories.length - 1]?.id === item?.id;
  const accept = () => {
    dispatch(
      acceptOrder({
        id: item.id,
        isAccept: true,
        data: {
          feedback: ' ',
        },
      }),
    ).then(({ payload }) => {
      if (payload?.id) {
        dispatch(getOrderHistory(order?.backupId));
        dispatch(getByIdOrders({ data: order }));
        onCancel();
        setNote('');
      }
    });
  };

  const reject = () => {
    setReject(true);
  };

  const confirmReject = useCallback(() => {
    dispatch(
      acceptOrder({
        id: item.id,
        isAccept: false,
        data: {
          feedback: note,
        },
      }),
    ).then(({ payload }) => {
      if (payload?.id) {
        dispatch(getOrderHistory(item?.orderId));
        dispatch(getByIdOrders({ data: order }));
        onCancel();
        setNote('');
      }
    });
    // eslint-disable-next-line
  }, [item, note]);

  if (isReject) {
    return (
      <div>
        {isLast && (
          <Typography.Title level={3}>
            {i18next.t(`orders.rejectOrderStatus.${item.status}`)}
          </Typography.Title>
        )}
        <div
          className="html-content"
          dangerouslySetInnerHTML={{ __html: item.note }}
        />
        <GridPhotos images={order?.products?.[0]?.productImages || []} />
        <br />
        <Editor
          // bounds=".app"
          // modules={modules}
          toolbar="undo redo | forecolor backcolor | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link media image"
          init={{
            height: '400',
            images_upload_handler: imageUploadHandler,
          }}
          plugins="code link checklist autolink image imagetools media"
          onEditorChange={(text) => {
            setNote(text);
          }}
        />
        <br />
        <br />
        {isLast ? (
          <div>
            <Button onClick={confirmReject} type="primary">
              {i18next.t('button.reject')}
            </Button>
            &nbsp;&nbsp;
            <Button onClick={() => setReject(false)}>
              {i18next.t('button.cancel')}
            </Button>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      {isLast && (
        <Typography.Title level={3}>
          {i18next.t(`orders.orderStatus.${item.status}`)}
        </Typography.Title>
      )}
      <div
        className="html-content"
        dangerouslySetInnerHTML={{ __html: item.note }}
      />
      <GridPhotos images={order?.products?.[0]?.productImages || []} />
      <br />
      {isLast ? (
        <div>
          <Button onClick={accept} type="primary">
            {i18next.t('button.accept')}
          </Button>
          &nbsp;&nbsp;
          {item.status !== 'pre_order' && (
            <Button onClick={reject}>{i18next.t('button.reject')}</Button>
          )}
        </div>
      ) : null}
    </div>
  );
};

WaitingApproved.propTypes = {
  order: PropTypes.object,
  item: PropTypes.object,
  onCancel: PropTypes.func,
};

export default WaitingApproved;
